// eslint-disable-next-line
import React, { useMemo } from "react";
import { TextureName, Textures } from "../sprites/texture";

export const useAnimation = (frames: TextureName[], textures: Textures) => {
  return useMemo(() => frames.map((t) => textures[t]!!), [textures, frames]);
};
